import parse from 'html-react-parser';

import { isObjectNull } from '../../../helpers/ObjectHelpers';
import { MapPropertiesProps, ShipTypeGroupsProps, ShipTypesProps } from './MapPropertiesServiceProps';
import MapPropertiesService from './MapPropertiesService';

export interface IMapElementService {
    getShipTypeDescription(obj: any): string,
    formatShipTypeIdentifierName(name: string): string,
    getShipTypeDescriptionBySystemName(systemName: string): string
}

class MapElementService implements IMapElementService {
    _mapTimer:NodeJS.Timeout | null = null;

    _mapProperties: MapPropertiesProps;
    _shipTypes: ShipTypesProps;
    _shipTypeGroups: ShipTypeGroupsProps;

    constructor() {
        this._mapProperties = MapPropertiesService.properties
        this._shipTypes = MapPropertiesService.shipTypes;
        this._shipTypeGroups = MapPropertiesService.shipTypeGroups
    }

    getShipTypeDescription(obj:any):string {
        if (isObjectNull(obj)) return "";
        if (obj.shipTypeIdentifier === this._shipTypes.PilotVessel) return "Tilbringer";
        return this.formatShipTypeIdentifierName(obj.shipTypeIdentifier);
    }

    formatShipTypeIdentifierName(name:string):string {
        if (name === "UNKNOWN") return "Annet/Ukjent";
        // Replaces underscore with space
        const nameWithoutUnderScore = name.replace(/_/g, ' ').toLowerCase();

        // Uppercases first letter of each word in name
        return nameWithoutUnderScore.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
    }

    getShipTypeDescriptionBySystemName(systemName:string):string {
        switch (systemName) {
            case this._shipTypeGroups.Cargo:
                return parse("Fraktb&aring;t") as string;
            case this._shipTypeGroups.Tanker: 
                return parse("Tankb&aring;t") as string;
            case this._shipTypeGroups.Passenger:
                return parse("Passasjerb&aring;t") as string;
            case this._shipTypeGroups.Fish:
                return parse("Fiskeb&aring;t") as string;
            case this._shipTypeGroups.Tug:
                return parse("Taub&aring;t") as string;
            default:
                return "Annet/Ukjent";
        }
    }
}

export default MapElementService;


